import { LoadingState } from '@lcs/shared/api';
import { createFeatureSelector, on } from '@ngrx/store';
import { OrderingDirections } from 'generated/graphql-types';
import { RegisterState } from 'src/app/common-components/register/models/register-state';
import {
   RegisterAdapter,
   createRegisterAdapter,
} from 'src/app/common-components/register/models/register-state.adapter';
import { accountIdChange } from 'src/app/store/select-account/select-account.actions';
import { LocationsFilterOption } from '../models/locations-filter-option';
import { LocationsOrderingOptions, LocationsRegisterOptions } from '../models/locations-register-options';
import { LocationsRegisterListItem } from '../models/locations-register-results.model';
import * as locationsRegisterActions from './locations-register.actions';

export const locationsRegisterFeatureKey = 'locationsRegister';

export interface LocationsRegisterState
   extends RegisterState<LocationsRegisterListItem, LocationsRegisterOptions, LocationsOrderingOptions> {
   filters: LocationsFilterOption[];
}

const adapter: RegisterAdapter<LocationsRegisterListItem, LocationsRegisterOptions, LocationsOrderingOptions> =
   createRegisterAdapter<LocationsRegisterListItem, LocationsRegisterOptions, LocationsOrderingOptions>({
      selectId: (locationsRegisterItem) => {
         return locationsRegisterItem.locationId ?? 0;
      },
   });

export const initialState: LocationsRegisterState = {
   ...adapter.getInitialState(),
   filters: [],
   orderingOptions: [{ direction: OrderingDirections.Asc, field: 'houseNumber' }],
};

export const locationsRegisterReducer = adapter.createReducer(
   locationsRegisterActions.locationsRegisterAdapterActions,
   initialState,
   on(locationsRegisterActions.locationsRegisterAdapterActions.pageEnter, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
      };
   }),
   on(locationsRegisterActions.locationsRegisterAdapterActions.loadSuccess, (state, action) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
         endCursor: action.endCursor,
         hasNextPage: action.hasNextPage,
         locations: action.items,
         totalCount: action.totalCount,
      };
   }),
   on(locationsRegisterActions.locationsRegisterAdapterActions.quickFilterChanged, (state, action) => {
      return {
         ...state,
         callState: LoadingState.Loading,
         quickFilters: {
            ...action.quickFilters,
         },
      };
   }),
   on(locationsRegisterActions.setOrderingOptionsFromSessionStorage, (state, action) => {
      return {
         ...state,
         orderingOptions: action.orderingOptions,
      };
   }),
   on(locationsRegisterActions.locationsRegisterInitialFilter, (state, action) => {
      return {
         ...state,
         filters: action.filters,
      };
   }),
   on(locationsRegisterActions.locationsRegisterAdapterActions.orderingOptionsChanged, (state, action) => {
      return {
         ...state,
         callState: LoadingState.Loading,
         orderingOptions: state.orderingOptions
            ? [
                 ...state.orderingOptions
                    .filter((option) => !action.orderingOptions.some((newOption) => newOption.field === option.field))
                    .filter((option) => option.direction !== OrderingDirections.NotSet),
                 ...action.orderingOptions,
              ]
            : action.orderingOptions,
      };
   }),
   on(accountIdChange, (state, action) => {
      return {
         ...state,
         quickFilters: null,
      };
   })
);
export const locationsRegisterSelector = createFeatureSelector<LocationsRegisterState>(locationsRegisterFeatureKey);
export const selectors = adapter.getSelectors(locationsRegisterSelector);
export const {
   selectAll,
   selectCallState,
   selectTotalCount,
   selectQuickFilters,
   selectEndCursor,
   selectOrderingOptions,
} = adapter.getSelectors(locationsRegisterSelector);
